import * as React from 'react';
import PlusIconBlue from '../assets/images/icon-plus-blue.svg';
import MinusIconBlue from '../assets/images/icon-minus-blue.svg';
import PlusIconWhite from '../assets/images/icon-plus-white.svg';
import MinusIconWhite from '../assets/images/icon-minus-white.svg';
import './Spinner.scss';

export interface IProps {
    onIncrement: () => void;
    onDecrement: () => void;
}

export const Spinner: React.FC<IProps> = ({ onIncrement, onDecrement }) => {
    return (
        <div className='edl-spinner-buttons'>
            <button className='edl-spinner-button edl-increment' onClick={onIncrement} data-test-id="spinner-button-increment">
                <img src={PlusIconBlue} alt="plus-blue" />
                <img src={PlusIconWhite} alt="plus-white" />
            </button>
            <button className='edl-spinner-button edl-decrement' onClick={onDecrement} data-test-id="spinner-button-decrement">
                <img src={MinusIconBlue} alt="minus-blue" />
                <img src={MinusIconWhite} alt="minus-white" />
            </button>
        </div>
    );
};
